/**
 * List of supported Segment Types
 * @param options object of options to build the list
 * @param options.includeEmpty boolean to include an empty name/value pair at the beginning
 */
export function list(options = {}) {
  const list = [
    {
      label: 'Standard',
      value: 'standard',
    },
    {
      label: 'Added Value',
      value: 'added-value',
    },
  ];

  if (options.includeEmpty === true) {
    list.unshift({
      label: '',
      value: '',
    });
  }

  return list;
}

export default {
  list,
};
